import { Box, Flex, Text } from 'rebass';
import PropTypes from 'prop-types';
import React, { useContext } from 'react';

import { StoryContext } from '../pages/story';
import SvgComment from './icons/SvgComment';
import SvgLikeOutline from './icons/SvgLikeOutline';
import useEntity from './hooks/useEntity';

const IconTotal = ({ total, children }) => (
  <Flex alignItems="center">
    {children}
    <Text pl={1} fontFamily="sans" color="mutedText" fontSize={1} lineHeight={1}>
      {total}
    </Text>
  </Flex>
);
IconTotal.propTypes = { total: PropTypes.number.isRequired, children: PropTypes.node.isRequired };

const SocialCount = ({ likesCount, commentsCount, ...props }) => (
  <Flex justifyContent="center" {...props}>
    <IconTotal total={likesCount}>
      <SvgLikeOutline />
    </IconTotal>
    <Box bg="rgb(243, 243, 243)" style={{ width: '1px' }} mx={2} my={1} />
    <IconTotal total={commentsCount}>
      <SvgComment />
    </IconTotal>
  </Flex>
);

SocialCount.propTypes = {
  likesCount: PropTypes.number.isRequired,
  commentsCount: PropTypes.number.isRequired,
};

export const StorySocialCount = () => {
  const id = useContext(StoryContext);
  const story = useEntity({ id, type: 'stories' });
  return (
    <SocialCount likesCount={story['like-count']} commentsCount={story['comment-count']} p={4} />
  );
};

export default SocialCount;
